import './../Status.scss';
import React, { useEffect, useRef, useState } from 'react'
import { useAppSelector } from '../../../../redux/hooks';
import { useDispatch } from 'react-redux';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Slider from '@mui/material/Slider';
import Grid from '@mui/material/Grid';
import Plot from "react-plotly.js";
import { DataName, SensorNodeStatus } from '../../../../util/model';

interface Props {
    index: number;
    plotHeight: number;
}

export default function BF3D(props: Props) {
    let ColorScale_Normal: Array<any> = [
        ['0.0', 'rgb(49,54,149)'],
        ['0.05', 'rgb(69,117,180)'],
        ['0.1', 'rgb(116,173,209)'],
        ['0.15', 'rgb(171,217,233)'],
        ['0.2', 'rgb(224,243,248)'],
        ['0.3', 'rgb(254,224,144)'],
        ['0.4', 'rgb(253,174,97)'],
        ['0.6', 'rgb(244,109,67)'],
        ['0.8', 'rgb(215,48,39)'],
        ['1.0', 'rgb(165,0,38)']];
    const [camAzi, setCamAzi] = useState(135.0);
    const [camEle, setCamEle] = useState(30.0);
    const [camDist, setCamDist] = useState(0.4);
    var bf3d_l1_layout = {
        height: props.plotHeight,
        showlegend: false,
        title: {
            text: 'Beamformer L1',
            font: {color: 'white', size: 12}
        },
        margin: {l: 0, r: 0, b: 0, t: 65},
        scene: {
            aspectmode: 'manual',
            aspectratio: {
                x: 1,
                y: 1,
                z: 1
            },
            xaxis:{
                title: 'Easting',
                color: 'white',
                tickfont: {color:'white'},
                range:  [-1, 1],
                showticklabels: false
            },
            yaxis: {
                title: 'Northing',
                color: 'white',
                tickfont: {color: 'white'},
                range:  [-1, 1],
                showticklabels: false
            },
            zaxis:{
                title: 'Up',
                color: 'white',
                tickfont: {color: 'white'},
                range:  [-1, 1],
                showticklabels: false
            },
            camera: {
                eye: {
                    x:camDist * Math.cos(camEle / 180.0 * Math.PI) * Math.sin(camAzi / 180.0 * Math.PI), 
                    y:camDist * Math.cos(camEle / 180.0 * Math.PI) * Math.cos(camAzi / 180.0 * Math.PI), 
                    z:camDist * Math.sin(camEle / 180.0 * Math.PI)
                },
                center: {x:0, y:0, z:0}
            }      
        },
        paper_bgcolor:'black'
    };
    const [layout_bf3d_l1, setBF3DL1Layout] = useState(bf3d_l1_layout);
    var bf3d_l1_data = [{
        type: 'scatter3d',
        mode: 'lines',
        x: [0,0,-0.3,0],
        y: [0.5,0,-0.5,0.5],
        z: [0,0,0,0],
        line: { width: 5, color: 'green'}
    },{
        type: 'mesh3d',
        x: [0,0,0.3],
        y: [0.5,0,-0.5],
        z: [0,0,0],
        color: 'green'
    },{
        type: 'scatter3d',
        mode: 'lines',
        x: [],
        y: [],
        z: [],
        line: { width: 1, cmin: -120, cmax: -90, color: [], colorscale: ColorScale_Normal}
    }];
    const [data_bf3d_l1, setBF3DL1Data] = useState(bf3d_l1_data);
    
    var bf3d_l2_layout = {
        height: props.plotHeight,
        showlegend: false,
        title: {
            text: 'Beamformer L2',
            font: {color: 'white', size: 12}
        },
        margin: {l: 0, r: 0, b: 0, t: 65},
        scene: {
            aspectmode: 'manual',
            aspectratio: {
                x: 1,
                y: 1,
                z: 1
            },
            xaxis:{
                title: 'Easting',
                color: 'white',
                tickfont: {color:'white'},
                range:  [-1, 1],
                showticklabels: false
            },
            yaxis: {
                title: 'Northing',
                color: 'white',
                tickfont: {color: 'white'},
                range:  [-1, 1],
                showticklabels: false
            },
            zaxis:{
                title: 'Up',
                color: 'white',
                tickfont: {color: 'white'},
                range:  [-1, 1],
                showticklabels: false
            },
            camera: {
                eye: {
                    x:camDist * Math.cos(camEle / 180.0 * Math.PI) * Math.sin(camAzi / 180.0 * Math.PI), 
                    y:camDist * Math.cos(camEle / 180.0 * Math.PI) * Math.cos(camAzi / 180.0 * Math.PI), 
                    z:camDist * Math.sin(camEle / 180.0 * Math.PI)
                },
                center: {x:0, y:0, z:0}
            }      
        },
        paper_bgcolor:'black'
    };
    const [layout_bf3d_l2, setBF3DL2Layout] = useState(bf3d_l2_layout);
    var bf3d_l2_data = [{
        type: 'scatter3d',
        mode: 'lines',
        x: [0,0,-0.3,0],
        y: [0.5,0,-0.5,0.5],
        z: [0,0,0,0],
        line: { width: 5, color: 'green'}
    },{
        type: 'mesh3d',
        x: [0,0,0.3],
        y: [0.5,0,-0.5],
        z: [0,0,0],
        color: 'green'
    },{
        type: 'scatter3d',
        mode: 'lines',
        x: [],
        y: [],
        z: [],
        line: { width: 1, cmin: -120, cmax: -90, color: [], colorscale: ColorScale_Normal}
    }];
    const [data_bf3d_l2, setBF3DL2Data] = useState(bf3d_l2_data);

    const dispatch = useDispatch();
    const layerData = useAppSelector(state => state.layerData);
    
    const SNTime = layerData.status.Time;
    const SNStatus = layerData.status.SensorNodeStatus;
    
    function setBF3D(bf: any, index: number) {
        var bf3d = [{
            type: 'scatter3d',
            mode: 'lines',
            x: [0,0,-0.3,0],
            y: [0.5,0,-0.5,0.5],
            z: [0,0,0,0],
            line: { width: 5, color: 'green'}
        },{
            type: 'mesh3d',
            x: [0,0,0.3],
            y: [0.5,0,-0.5],
            z: [0,0,0],
            color: 'green'
        },{
            type: 'scatter3d',
            mode: 'lines',
            x: [],
            y: [],
            z: [],
            line: { width: 1, cmin: -120, cmax: -90, color: [], colorscale: ColorScale_Normal}
        }];
        var dEleStep = 0.5 * Math.PI / bf[index].Beamformer.length;
        var vdAziStep: Array<number> = [];
        for(var m = 0; m < bf[index].Beamformer.length; ++m) {
            var dAziStep = 2.0 * Math.PI / bf[index].Beamformer[m].length;
            vdAziStep.push(dAziStep);
        }
        var dX: Array<number> = [];
        var dY: Array<number> = [];
        var dZ: Array<number> = [];
        var dValue: Array<number> = [];
        for(var i = 0; i < bf[index].Beamformer.length; ++i) {
            for(var j = 0; j < bf[index].Beamformer[i].length; ++j) {
                var dV = bf[index].Beamformer[i][j];
                var dLength = (dV + 130.0) / 40.0;
                var dAzi = vdAziStep[i] * j;
                var dEle = dEleStep * i;
                var X = dLength * Math.cos(dEle) * Math.sin(dAzi);
                var Y = dLength * Math.cos(dEle) * Math.cos(dAzi);
                var Z = dLength * Math.sin(dEle);
                dX.push(X);
                dY.push(Y);
                dZ.push(Z);
                dValue.push(bf[index].Beamformer[i][j]);
                dX.push(0.0);
                dY.push(0.0);
                dZ.push(0.0);
                dValue.push(bf[index].Beamformer[i][j]);
            }
        }
        bf3d[2].x = dX as any;
        bf3d[2].y = dY as any;
        bf3d[2].z = dZ as any;
        if(bf3d[2].line) {
            bf3d[2].line.color = dValue as any;
        }
        if(index == 0) {
            setBF3DL1Data(bf3d);
        } else if(index == 1) {
            setBF3DL2Data(bf3d);
        }
    }
    
    function initBF3D(index: number) {
        var bf3d = [{
            type: 'scatter3d',
            mode: 'lines',
            x: [0,0,-0.3,0],
            y: [0.5,0,-0.5,0.5],
            z: [0,0,0,0],
            line: { width: 5, color: 'green'}
        },{
            type: 'mesh3d',
            x: [0,0,0.3],
            y: [0.5,0,-0.5],
            z: [0,0,0],
            color: 'green'
        },{
            type: 'scatter3d',
            mode: 'lines',
            x: [],
            y: [],
            z: [],
            line: { width: 1, cmin: -120, cmax: -90, color: [], colorscale: ColorScale_Normal}
        }];
        if(index == 0) {
            setBF3DL1Data(bf3d);
        } else if(index == 1) {
            setBF3DL2Data(bf3d);
        }
    }
    
    useEffect(() => {
        if((props.index >= 0) && (props.index < SNStatus.length)) {
            if(SNStatus[props.index].Beamformer.Array.length >= 2) {
                var localTime = new Date(SNStatus[props.index].Beamformer.Time);
                setBF3D(SNStatus[props.index].Beamformer.Array, 0);
                setBF3D(SNStatus[props.index].Beamformer.Array, 1);
                var bf3d_l1_layout = layout_bf3d_l1;
                bf3d_l1_layout.title.text = SNStatus[props.index].Name + ' Beamformer L1 ' + localTime.toLocaleString();
                setBF3DL1Layout(bf3d_l1_layout);
                var bf3d_l2_layout = layout_bf3d_l2;
                bf3d_l2_layout.title.text = SNStatus[props.index].Name + ' Beamformer L2 ' + localTime.toLocaleString();
                setBF3DL2Layout(bf3d_l2_layout);
            } else {
                initBF3D(0);
                initBF3D(1);
            }
        } else {
            initBF3D(0);
            initBF3D(1);
        } 
        
    }, [SNTime, props.index]);
    
    useEffect(() => {
        var bf3d_l1_layout = layout_bf3d_l1;
        bf3d_l1_layout.height = props.plotHeight;
        setBF3DL1Layout(bf3d_l1_layout);
        var bf3d_l2_layout = layout_bf3d_l2;
        bf3d_l2_layout.height = props.plotHeight;
        setBF3DL2Layout(bf3d_l2_layout);
    }, [props.plotHeight]);
    
    useEffect(() => {
        var bf3d_l1_layout = layout_bf3d_l1;
        bf3d_l1_layout.scene.camera.eye.x = camDist * Math.cos(camEle / 180.0 * Math.PI) * Math.sin(camAzi / 180.0 * Math.PI); 
        bf3d_l1_layout.scene.camera.eye.y = camDist * Math.cos(camEle / 180.0 * Math.PI) * Math.cos(camAzi / 180.0 * Math.PI);
        bf3d_l1_layout.scene.camera.eye.z = camDist * Math.sin(camEle / 180.0 * Math.PI);
        setBF3DL1Layout(bf3d_l1_layout);
        var bf3d_l2_layout = layout_bf3d_l2;
        bf3d_l2_layout.scene.camera.eye.x = camDist * Math.cos(camEle / 180.0 * Math.PI) * Math.sin(camAzi / 180.0 * Math.PI); 
        bf3d_l2_layout.scene.camera.eye.y = camDist * Math.cos(camEle / 180.0 * Math.PI) * Math.cos(camAzi / 180.0 * Math.PI);
        bf3d_l2_layout.scene.camera.eye.z = camDist * Math.sin(camEle / 180.0 * Math.PI);
        setBF3DL2Layout(bf3d_l2_layout);
    }, [camAzi, camEle, camDist]);
    
    function ZoomChange(value: number) {
        setCamDist(value);
    }
    
    function AziChange(value: number) {
        setCamAzi(value);
    }
    
    function EleChange(value: number) {
        setCamEle(value);
    }

    return (
        <div>
            <Table><TableBody><TableRow className='graph_d_row' style={{border: '1px solid rgba(0, 0, 0, 1)', backgroundColor: 'black', height: '10%', alignItems: 'center'}}>
                <TableCell style={{border: '10px solid rgba(0, 0, 0, 1)', width: '95%', backgroundColor: 'black'}} padding='none'>
                    <Plot data={data_bf3d_l1 as any} layout={layout_bf3d_l1 as any} useResizeHandler={true} style={{ width: '100%', height: '100%' }}/>
                </TableCell>
                <TableCell style={{border: '10px solid rgba(0, 0, 0, 1)', width: '95%', backgroundColor: 'black'}} padding='none'>
                    <Plot data={data_bf3d_l2 as any} layout={layout_bf3d_l2 as any} useResizeHandler={true} style={{ width: '100%', height: '100%' }}/>
                </TableCell>
            </TableRow></TableBody></Table>
            <Grid style={{width: '100%', margin: '0', maxWidth: '95%', marginLeft: 'auto'}} container spacing={2} sx={{ alignItems: 'center' }}>
                <Grid item style={{color: 'white'}}>
                    Camera Settings
                </Grid>
            </Grid>
            <Grid className='three_d_line' style={{width: 'auto', maxWidth: '95%', margin: '0 auto'}} container spacing={2} sx={{ alignItems: 'center' }}>
                <Grid item style={{color: 'white'}}>
                    Zoom Level
                </Grid>
                <Grid item xs>
                    <Slider defaultValue={0.7} min={0.3} max={2.0} step={0.01} getAriaValueText={ZoomChange as any} aria-label='Default' valueLabelDisplay='auto'/>
                </Grid>
		<Grid item style={{color: 'white'}}>
                    Azimuth (deg)
                </Grid>
                <Grid item xs>
                    <Slider defaultValue={135} min={0} max={360} step={1} getAriaValueText={AziChange as any} aria-label='Default' valueLabelDisplay='auto' />
                </Grid>
		<Grid item style={{color: 'white'}}>
                    Elevation (deg)
                </Grid>
                <Grid item xs>
                    <Slider defaultValue={30} min={0} max={90} step={1} getAriaValueText={EleChange as any} aria-label="Default" valueLabelDisplay="auto" />
                </Grid>
            </Grid>
        </div>
    )
}
